exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-position span[data-v-b470efd2] {\n  cursor: pointer;\n}\n.wizard-position span.disabled[data-v-b470efd2] {\n  cursor: not-allowed;\n}\n.small-header[data-v-b470efd2] {\n  color: #9d9d9d;\n}\n", ""]);

// exports
